/**
 * The values in this enum must NOT change.
 * Central Entities Service uses these values to identify entities, and these values
 * create stable identifiers for the Activate Entities.
 *
 * Changing these would alter the composite IDs, which are used as stable identifiers.
 * Changing these would prevent Activate from finding the existing entities in Central Entities Service.
 */
export enum ActivateSourceType {
  Floor = 'floor',
  Unit = 'unit',
  Building = 'channel.building',
  Organization = 'channel.organization',
  Person = 'person',
  User = 'user',
  Company = 'channel.company',
  Location = 'channel.location',
}

export enum RelationshipSourceType {
  LEASE = 'lease',
  INVALID = 'invalid',
}

export enum EntityType {
  BUILDING = 'ENTITY_TYPE_BUILDING',
  UNIT = 'ENTITY_TYPE_UNIT',
  PERSON = 'ENTITY_TYPE_PERSON',
  COMPANY = 'ENTITY_TYPE_COMPANY',
  FLOOR = 'ENTITY_TYPE_FLOOR',
  LOCATION = 'ENTITY_TYPE_LOCATION',
  AMENITY = 'ENTITY_TYPE_AMENITY',
  BUILDING_COLLECTION = 'ENTITY_TYPE_BUILDING_COLLECTION',
  NULL = 'ENTITY_TYPE_NULL',
  INVALID = 'ENTITY_TYPE_INVALID',
}

export enum SourceType {
  ACTIVATE = 'SOURCE_TYPE_ACTIVATE',
  YARDI = 'SOURCE_TYPE_YARDI',
  MRI = 'SOURCE_TYPE_MRI',
  REAL_PAGE = 'SOURCE_TYPE_REAL_PAGE',
  ENTRATA = 'SOURCE_TYPE_ENTRATA',
  VCM = 'SOURCE_TYPE_VCM',
  SFDC = 'SOURCE_TYPE_SFDC',
  CBRE = 'SOURCE_TYPE_CBRE',
  INVALID = 'SOURCE_TYPE_INVALID',
}

export enum RelationshipType {
  LEASES = 'RELATIONSHIP_TYPE_LEASES',
  OWNS = 'RELATIONSHIP_TYPE_OWNS',
  MANAGES = 'RELATIONSHIP_TYPE_MANAGES',
  OCCUPIES = 'RELATIONSHIP_TYPE_OCCUPIES',
  EMPLOYS = 'RELATIONSHIP_TYPE_EMPLOYS',
  CONTAINS = 'RELATIONSHIP_TYPE_CONTAINS',
  REFERENCES = 'RELATIONSHIP_TYPE_REFERENCES',
  IS = 'RELATIONSHIP_TYPE_IS',
  HAS = 'RELATIONSHIP_TYPE_HAS',
  INVALID = 'RELATIONSHIP_TYPE_INVALID',
}

export enum AreaUnit {
  SQUARE_METERS = 'AREA_UNIT_SQUARE_METERS',
  SQUARE_FEET = 'AREA_UNIT_SQUARE_FEET',
  INVALID = 'AREA_UNIT_INVALID',
}

export enum PhoneType {
  MOBILE = 'PHONE_TYPE_MOBILE',
  HOME = 'PHONE_TYPE_HOME',
  OFFICE = 'PHONE_TYPE_OFFICE',
  INVALID = 'PHONE_TYPE_INVALID',
}

export enum UnitType {
  OTHER_INVALID = 'UNIT_TYPE_OTHER_INVALID',
  OFFICE = 'UNIT_TYPE_OFFICE',
  RETAIL = 'UNIT_TYPE_RETAIL',
  INDUSTRIAL_WAREHOUSE = 'UNIT_TYPE_INDUSTRIAL_WAREHOUSE',
  TELECOM = 'UNIT_TYPE_TELECOM',
  STORAGE = 'UNIT_TYPE_STORAGE',
  FLEX = 'UNIT_TYPE_FLEX',
  PARKING = 'UNIT_TYPE_PARKING',
  ROOFTOP = 'UNIT_TYPE_ROOFTOP',
  LAB = 'UNIT_TYPE_LAB',
  MANUFACTURING = 'UNIT_TYPE_MANUFACTURING',
  RESIDENTIAL = 'UNIT_TYPE_RESIDENTIAL',
  MEDICAL_OFFICE = 'UNIT_TYPE_MEDICAL_OFFICE',
  EDUCATION = 'UNIT_TYPE_EDUCATION',
  RESTAURANT = 'UNIT_TYPE_RESTAURANT',
  LEISURE = 'UNIT_TYPE_LEISURE',
  UNSPECIFIED = 'UNIT_TYPE_UNSPECIFIED',
  UNRECOGNIZED = 'UNIT_TYPE_UNRECOGNIZED',
}

export enum BuildingType {
  OFFICE = 'BUILDING_TYPE_OFFICE',
  RETAIL = 'BUILDING_TYPE_RETAIL',
  INDUSTRIAL = 'BUILDING_TYPE_INDUSTRIAL',
  RESIDENTIAL = 'BUILDING_TYPE_RESIDENTIAL',
  OTHER = 'BUILDING_TYPE_OTHER',
  UNRECOGNIZED = 'BUILDING_TYPE_UNRECOGNIZED',
}

export enum BuildingClass {
  A = 'BUILDING_CLASS_A',
  B = 'BUILDING_CLASS_B',
  C = 'BUILDING_CLASS_C',
  UNRECOGNIZED = 'BUILDING_CLASS_UNRECOGNIZED',
}

export enum IndustryCode {
  ANZSIC = 'INDUSTRY_CODE_ANZSIC',
  BICS = 'INDUSTRY_CODE_BICS',
  GICS = 'INDUSTRY_CODE_GICS',
  HSICS = 'INDUSTRY_CODE_HSICS',
  IBBICS = 'INDUSTRY_CODE_IBBICS',
  ICB = 'INDUSTRY_CODE_ICB',
  ISIC = 'INDUSTRY_CODE_ISIC',
  MGECS = 'INDUSTRY_CODE_MGECS',
  NACE = 'INDUSTRY_CODE_NACE',
  NAICS = 'INDUSTRY_CODE_NAICS',
  RBICS = 'INDUSTRY_CODE_RBICS',
  SIC = 'INDUSTRY_CODE_SIC',
  SNI = 'INDUSTRY_CODE_SNI',
  TRBC = 'INDUSTRY_CODE_TRBC',
  UKSIC = 'INDUSTRY_CODE_UKSIC',
  UNSPSC = 'INDUSTRY_CODE_UNSPSC',
  INVALID = 'INDUSTRY_CODE_INVALID',
  UNRECOGNIZED = 'INDUSTRY_CODE_UNRECOGNIZED',
}

export enum CurrencyCode {
  INVALID = 'CURRENCY_CODE_INVALID',
  AED = 'CURRENCY_CODE_AED',
  AFN = 'CURRENCY_CODE_AFN',
  ALL = 'CURRENCY_CODE_ALL',
  AMD = 'CURRENCY_CODE_AMD',
  ANG = 'CURRENCY_CODE_ANG',
  AOA = 'CURRENCY_CODE_AOA',
  ARS = 'CURRENCY_CODE_ARS',
  AUD = 'CURRENCY_CODE_AUD',
  AWG = 'CURRENCY_CODE_AWG',
  AZN = 'CURRENCY_CODE_AZN',
  BAM = 'CURRENCY_CODE_BAM',
  BBD = 'CURRENCY_CODE_BBD',
  BDT = 'CURRENCY_CODE_BDT',
  BGN = 'CURRENCY_CODE_BGN',
  BHD = 'CURRENCY_CODE_BHD',
  BIF = 'CURRENCY_CODE_BIF',
  BMD = 'CURRENCY_CODE_BMD',
  BND = 'CURRENCY_CODE_BND',
  BOB = 'CURRENCY_CODE_BOB',
  BOV = 'CURRENCY_CODE_BOV',
  BRL = 'CURRENCY_CODE_BRL',
  BSD = 'CURRENCY_CODE_BSD',
  BTN = 'CURRENCY_CODE_BTN',
  BWP = 'CURRENCY_CODE_BWP',
  BYN = 'CURRENCY_CODE_BYN',
  BZD = 'CURRENCY_CODE_BZD',
  CAD = 'CURRENCY_CODE_CAD',
  CDF = 'CURRENCY_CODE_CDF',
  CHE = 'CURRENCY_CODE_CHE',
  CHF = 'CURRENCY_CODE_CHF',
  CHW = 'CURRENCY_CODE_CHW',
  CLF = 'CURRENCY_CODE_CLF',
  CLP = 'CURRENCY_CODE_CLP',
  COP = 'CURRENCY_CODE_COP',
  COU = 'CURRENCY_CODE_COU',
  CRC = 'CURRENCY_CODE_CRC',
  CUP = 'CURRENCY_CODE_CUP',
  CVE = 'CURRENCY_CODE_CVE',
  CZK = 'CURRENCY_CODE_CZK',
  DJF = 'CURRENCY_CODE_DJF',
  DKK = 'CURRENCY_CODE_DKK',
  DOP = 'CURRENCY_CODE_DOP',
  DZD = 'CURRENCY_CODE_DZD',
  EGP = 'CURRENCY_CODE_EGP',
  ERN = 'CURRENCY_CODE_ERN',
  ETB = 'CURRENCY_CODE_ETB',
  EUR = 'CURRENCY_CODE_EUR',
  FJD = 'CURRENCY_CODE_FJD',
  FKP = 'CURRENCY_CODE_FKP',
  GBP = 'CURRENCY_CODE_GBP',
  GEL = 'CURRENCY_CODE_GEL',
  GHS = 'CURRENCY_CODE_GHS',
  GIP = 'CURRENCY_CODE_GIP',
  GMD = 'CURRENCY_CODE_GMD',
  GNF = 'CURRENCY_CODE_GNF',
  GTQ = 'CURRENCY_CODE_GTQ',
  GYD = 'CURRENCY_CODE_GYD',
  HKD = 'CURRENCY_CODE_HKD',
  HNL = 'CURRENCY_CODE_HNL',
  HTG = 'CURRENCY_CODE_HTG',
  HUF = 'CURRENCY_CODE_HUF',
  IDR = 'CURRENCY_CODE_IDR',
  ILS = 'CURRENCY_CODE_ILS',
  INR = 'CURRENCY_CODE_INR',
  IQD = 'CURRENCY_CODE_IQD',
  IRR = 'CURRENCY_CODE_IRR',
  ISK = 'CURRENCY_CODE_ISK',
  JMD = 'CURRENCY_CODE_JMD',
  JOD = 'CURRENCY_CODE_JOD',
  JPY = 'CURRENCY_CODE_JPY',
  KES = 'CURRENCY_CODE_KES',
  KGS = 'CURRENCY_CODE_KGS',
  KHR = 'CURRENCY_CODE_KHR',
  KMF = 'CURRENCY_CODE_KMF',
  KPW = 'CURRENCY_CODE_KPW',
  KRW = 'CURRENCY_CODE_KRW',
  KWD = 'CURRENCY_CODE_KWD',
  KYD = 'CURRENCY_CODE_KYD',
  KZT = 'CURRENCY_CODE_KZT',
  LAK = 'CURRENCY_CODE_LAK',
  LBP = 'CURRENCY_CODE_LBP',
  LKR = 'CURRENCY_CODE_LKR',
  LRD = 'CURRENCY_CODE_LRD',
  LSL = 'CURRENCY_CODE_LSL',
  LYD = 'CURRENCY_CODE_LYD',
  MAD = 'CURRENCY_CODE_MAD',
  MDL = 'CURRENCY_CODE_MDL',
  MGA = 'CURRENCY_CODE_MGA',
  MKD = 'CURRENCY_CODE_MKD',
  MMK = 'CURRENCY_CODE_MMK',
  MNT = 'CURRENCY_CODE_MNT',
  MOP = 'CURRENCY_CODE_MOP',
  MRU = 'CURRENCY_CODE_MRU',
  MUR = 'CURRENCY_CODE_MUR',
  MVR = 'CURRENCY_CODE_MVR',
  MWK = 'CURRENCY_CODE_MWK',
  MXN = 'CURRENCY_CODE_MXN',
  MXV = 'CURRENCY_CODE_MXV',
  MYR = 'CURRENCY_CODE_MYR',
  MZN = 'CURRENCY_CODE_MZN',
  NAD = 'CURRENCY_CODE_NAD',
  NGN = 'CURRENCY_CODE_NGN',
  NIO = 'CURRENCY_CODE_NIO',
  NOK = 'CURRENCY_CODE_NOK',
  NPR = 'CURRENCY_CODE_NPR',
  NZD = 'CURRENCY_CODE_NZD',
  OMR = 'CURRENCY_CODE_OMR',
  PAB = 'CURRENCY_CODE_PAB',
  PEN = 'CURRENCY_CODE_PEN',
  PGK = 'CURRENCY_CODE_PGK',
  PHP = 'CURRENCY_CODE_PHP',
  PKR = 'CURRENCY_CODE_PKR',
  PLN = 'CURRENCY_CODE_PLN',
  PYG = 'CURRENCY_CODE_PYG',
  QAR = 'CURRENCY_CODE_QAR',
  RON = 'CURRENCY_CODE_RON',
  RSD = 'CURRENCY_CODE_RSD',
  CNY = 'CURRENCY_CODE_CNY',
  RUB = 'CURRENCY_CODE_RUB',
  RWF = 'CURRENCY_CODE_RWF',
  SAR = 'CURRENCY_CODE_SAR',
  SBD = 'CURRENCY_CODE_SBD',
  SCR = 'CURRENCY_CODE_SCR',
  SDG = 'CURRENCY_CODE_SDG',
  SEK = 'CURRENCY_CODE_SEK',
  SGD = 'CURRENCY_CODE_SGD',
  SHP = 'CURRENCY_CODE_SHP',
  SLE = 'CURRENCY_CODE_SLE',
  SLL = 'CURRENCY_CODE_SLL',
  SOS = 'CURRENCY_CODE_SOS',
  SRD = 'CURRENCY_CODE_SRD',
  SSP = 'CURRENCY_CODE_SSP',
  STN = 'CURRENCY_CODE_STN',
  SVC = 'CURRENCY_CODE_SVC',
  SYP = 'CURRENCY_CODE_SYP',
  SZL = 'CURRENCY_CODE_SZL',
  THB = 'CURRENCY_CODE_THB',
  TJS = 'CURRENCY_CODE_TJS',
  TMT = 'CURRENCY_CODE_TMT',
  TND = 'CURRENCY_CODE_TND',
  TOP = 'CURRENCY_CODE_TOP',
  TRY = 'CURRENCY_CODE_TRY',
  TTD = 'CURRENCY_CODE_TTD',
  TWD = 'CURRENCY_CODE_TWD',
  TZS = 'CURRENCY_CODE_TZS',
  UAH = 'CURRENCY_CODE_UAH',
  UGX = 'CURRENCY_CODE_UGX',
  USD = 'CURRENCY_CODE_USD',
  USN = 'CURRENCY_CODE_USN',
  UYI = 'CURRENCY_CODE_UYI',
  UYU = 'CURRENCY_CODE_UYU',
  UYW = 'CURRENCY_CODE_UYW',
  UZS = 'CURRENCY_CODE_UZS',
  VED = 'CURRENCY_CODE_VED',
  VES = 'CURRENCY_CODE_VES',
  VND = 'CURRENCY_CODE_VND',
  VUV = 'CURRENCY_CODE_VUV',
  WST = 'CURRENCY_CODE_WST',
  XAF = 'CURRENCY_CODE_XAF',
  XAG = 'CURRENCY_CODE_XAG',
  XAU = 'CURRENCY_CODE_XAU',
  XBA = 'CURRENCY_CODE_XBA',
  XBB = 'CURRENCY_CODE_XBB',
  XBC = 'CURRENCY_CODE_XBC',
  XBD = 'CURRENCY_CODE_XBD',
  XCD = 'CURRENCY_CODE_XCD',
  XDR = 'CURRENCY_CODE_XDR',
  XOF = 'CURRENCY_CODE_XOF',
  XPD = 'CURRENCY_CODE_XPD',
  XPF = 'CURRENCY_CODE_XPF',
  XPT = 'CURRENCY_CODE_XPT',
  XSU = 'CURRENCY_CODE_XSU',
  XTS = 'CURRENCY_CODE_XTS',
  XUA = 'CURRENCY_CODE_XUA',
  XXX = 'CURRENCY_CODE_XXX',
  YER = 'CURRENCY_CODE_YER',
  ZAR = 'CURRENCY_CODE_ZAR',
  ZMW = 'CURRENCY_CODE_ZMW',
  ZWL = 'CURRENCY_CODE_ZWL',
  UNRECOGNIZED = 'CURRENCY_CODE_UNRECOGNIZED',
}
